// extracted by mini-css-extract-plugin
export var wrap = "footerNav-module--wrap--3vY_f";
export var wrapMobileVisible = "footerNav-module--wrapMobileVisible--2t8Xm";